<template>
    <div v-if="isLoading" class="col-12">
        <!-- begin loader -->
        <beat-loader-component v-if="isLoading" :isLoading="isLoading"></beat-loader-component>
        <!-- end loader -->
    </div>
    <form v-else class="row" @submit.prevent="submitTransactions">
        <div class="col-md-12 text-center">
            <errors v-if="errors_msg?.message">
                {{ errors_msg.message }}
            </errors>
        </div>
        <form-transaction :form="form" :add_or_edit="false"
            :coa_subhead_options="coa_subhead_options"></form-transaction>
        <hr class="mt-4" />
        <div class="col-12 text-end">
            <button type="submit" :disabled="isSaving" class="btn akkurate-green-btn text-white btn-size my-2 me-3">
                <span class="small">
                    <font-awesome-icon class="me-2" :icon="['fas', 'save']" />Update
                </span>
            </button>
        </div>
    </form>
</template>
<script>
import Multiselect from "vue-multiselect";
import ApiService from "@/core/services/api.service";
import FormTransaction from "./FormTransaction.vue";

export default {
    components: {
        Multiselect,
        FormTransaction
    },
    data() {
        return {
            isLoading: false,
            errors_msg: {},
            coa_subhead: {},
            isSaving: false,
            form: {
                cr_amount: "",
                dr_amount: "",
                coa_subhead_id: "",
                transaction_description: "",
                branch_id: "",
            }
        }
    },
    props: {
        coa_data: {
            required: true
        },
        coa_subhead_options: {
            required: true
        }
    },
    mounted() {
        if (this.coa_subhead_options.length > 0) {
            this.form = {
                cr_amount: this.coa_data?.cr_amount,
                dr_amount: this.coa_data?.dr_amount,
                coa_subhead_id: this.coa_subhead_options.filter((index) => index.id == this.coa_data?.coa_subhead_id),
                transaction_description: this.coa_data?.transaction_description,
                branch_id: this.coa_subhead?.branch_id,
                transaction_date: this.coa_data?.transaction_date
            }
        }

    },
    methods: {
        submitTransactions() {
            this.isSaving = true;
            let form = {
                'cr_amount': this.form?.cr_amount,
                'dr_amount': this.form?.dr_amount,
                'coa_subhead_id': this.form?.coa_subhead_id?.id,
                'transaction_description': this.form?.transaction_description,
                'branch_id': this.form?.coa_subhead_id?.coabranch?.id,
                'transaction_date': this.form?.transaction_date,
            }
            ApiService.put("/finance/coa-transactions/" + this.coa_data.id, form)
                .then((response) => {
                    this.isSaving = false;
                    this.$Progress.finish();
                    this.save = "Save";
                    toast.fire({
                        icon: "success",
                        title: response.data.message,
                    });
                    this.errors_msg = {};
                    this.$emit('savedEdit')
                })
                .catch((error) => {
                    this.isSaving = false;
                    this.$Progress.fail();
                    this.save = "Save";
                    if (error.response.data) {
                        // Clear previous errors
                        this.errors_msg = {};

                        // Set general message
                        this.errors_msg.message = error.response.data.message;
                        // Set field-specific errors if they exist
                        if (error.response.data.errors) {
                            Object.keys(error.response.data.errors).forEach(key => {
                                this.errors_msg[key] = error.response.data.errors[key];
                            });
                        }
                    }
                });
        },
    }

}
</script>